import { render } from "./MatchCard.vue?vue&type=template&id=216468ec&ts=true"
import script from "./MatchCard.vue?vue&type=script&lang=ts"
export * from "./MatchCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__